/**
 * RequireLogin.jsx
 * Created by aishwarsabesan on 6/20/18.
 * Only to be used with external site pages
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { isLoggedIn } from '../helpers/securityHelper';
import { showLoginModal } from '../actions/navigation/loginActions';

export default (WrappedComponent) => {
  class AuthHOC extends React.Component {
    componentWillMount() {
      if (!isLoggedIn()) {
        this.props.dispatch(showLoginModal());
      }
    }

    render() {
      if (this.props.account) {
        return <WrappedComponent {...this.props} />
      }

      return <div /> // TODO: Design nice message to say please login
    }
  }

  function mapStateToProps(state) {
    return {
      account: state.auth.account
    }
  }

  AuthHOC.propTypes = {
    dispatch: PropTypes.func,
    account: PropTypes.object
  };

  return connect(mapStateToProps)(AuthHOC);
}
